var map = {
	"./Announcement.vue": [
		"63ec",
		"landing-Announcement-vue"
	],
	"./AnnouncementType.vue": [
		"4edd",
		"landing-AnnouncementType-vue"
	],
	"./Faq.vue": [
		"9507",
		"landing-Faq-vue"
	],
	"./Slider.vue": [
		"a6b5",
		"landing-Slider-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a831";
module.exports = webpackAsyncContext;